// components
import Image from 'next/image';
import VisibleLoading from '@/components/utilities/VisibleLoading';

// utilities
import { getImagePath } from '@/utils/images';

const ReferencesBlock = ({ references }) => {
  return (
    <div className="no-scrollbar mx-auto my-12 flex w-full flex-wrap items-center justify-center gap-12 overflow-x-auto px-4 py-4 xl:flex-wrap xl:justify-center xl:overflow-x-visible xl:px-0">
      {(references || []).map((reference, index) => (
        <VisibleLoading key={reference.id} delay={index * 100} opacity={50}>
          {({ ref, className }) => (
            <Image
              ref={ref}
              src={getImagePath(reference.image)}
              alt={reference.name}
              width={reference.image.width}
              height={reference.image.height}
              className={`max-h-9 w-auto object-contain ${className || ''}`.trim()}
            />
          )}
        </VisibleLoading>
      ))}
    </div>
  );
};
export default ReferencesBlock;
